import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { FieldType } from '@ngx-formly/core';

@Component({
	selector: 'formly-chip-list',
	template: `
		<mat-chip-set aria-label="Chip List" class="chip-list-type-wrapper">
			<mat-chip *ngFor="let chip of props.options; let i = index" (removed)="remove(chip, i)" class="linq-chip">
				{{ chip.label }}
				<button matChipRemove *ngIf="props.allowRemove === true">
					<mat-icon>cancel</mat-icon>
				</button>
			</mat-chip>
		</mat-chip-set>
	`,
	standalone: true,
	imports: [MatChipsModule, NgFor, NgIf, MatIconModule],
})
export class FormlyChipListComponent extends FieldType {
	remove(chip: any, index: number): void {
		const options = this.props.options as any[];
		options.splice(index, 1);

		if (this.props.removed) {
			this.props.removed(chip);
		}
	}
}
